import { xs_languageCode } from "../..";
import { getLSItemOrEmptyString } from '../utils/getLSItemOrEmptyString';

let betTemplates = null;

export let getBetTpl = function(sportId, betId) {
    const templatesJson = getLSItemOrEmptyString('xs_templates');
    betTemplates = templatesJson.length > 0 ? JSON.parse(templatesJson) : {};
    getBetTpl = (sportId, betId) => {
        return betTemplates[`${sportId}_${betId}`] || null;
    };
    return getBetTpl(sportId, betId);
}

export function hasTemplate(sportId, betId) {
    return getBetTpl(sportId, betId) != null;
}

export function getLayoutFromTpl(betTpl) {
    if (betTpl == null) {
        return null;
    }
    
    return (betTpl?.layout ?? null) || null;
}

export function getCustomBetLayout(sportId, betId) {
    const betTpl = getBetTpl(sportId, betId);
    return getLayoutFromTpl(betTpl);
}

export function getDescFromTpl(betTpl) {
    if (betTpl == null) {
        return null;
    }

    const languageMap = betTpl?.dsl ?? null;
    if (languageMap == null) {
        return null;
    }
    
    return languageMap[xs_languageCode] || languageMap[xs_languageCode.toLowerCase()] || null;
}

export function getCustomBetDesc(sportId, betId) {
    const betTpl = getBetTpl(sportId, betId);
    return getDescFromTpl(betTpl);
}
